import * as types from './mutations-types';
import api from './api';

export default {
	defaultAssign_({ commit }, { key, value }) {
		commit(types.DEFAULT_ASSIGN, {
			key,
			value
		});
	},
	async getPlants_({ commit }) {
		let data = await api.getPlants();
		let options = [];

		if (data.header.code === 0) {
			if (data.body) {
				data.body.map(v => {
					if (v.commCdName !== 'PLANT') {
						options.push({ label: v.commCdName, value: v.commCd });
					}
				});
			}

			commit(types.DEFAULT_ASSIGN, {
				key: 'plants',
				value: options
			});
		}

		if (data.header.code === 1) {
		}
		if (data.header.code === 2) {
		}
		if (data.header.code === 3) {
		}
		if (data.header.code === 4) {
		}
		if (data.header.code === 5) {
		}

		if (data.header.code === 500) {
			// somethinig todo
		}

		return data.header;
	},
	async getLogTypes_({ commit }, { plantCd, commCdType }) {
		let data = await api.getLogTypes({ plantCd, commCdType });
		let options = [];

		if (data.header.code === 0) {
			if (data.body) {
				options.push({ label: 'All', value: '' });
				data.body.map(v => {
					if (v.commCd != 'B' && v.commCd != 'U' && v.commCd != 'L') {
						options.push({ label: `${v.commCd} ${v.commCdName}`, value: v.commCd });
					}
				});
			}
			commit(types.DEFAULT_ASSIGN, {
				key: 'logTypes',
				value: options
			});
		}

		if (data.header.code === 1) {
		}
		if (data.header.code === 2) {
		}
		if (data.header.code === 3) {
		}
		if (data.header.code === 4) {
		}
		if (data.header.code === 5) {
		}

		if (data.header.code === 500) {
			// somethinig todo
		} else {
			// somethinig todo
		}

		return data.header;
	},
	async getErrorLogList_({ commit }, { searchParams, currentPage, pageUnit }) {
		let store = this.state.errorLogStore;
		let data = await api.getErrorLogList({ searchParams, currentPage, pageUnit });

		if (data.header.code === 0) {
			let body = data.body.resultList;

			body.map((object, index) => {
				object.test = index;
			});
			commit(types.DEFAULT_ASSIGN, {
				key: 'resultList',
				value: body
			});
			commit(types.DEFAULT_ASSIGN, {
				key: 'groups',
				value: data.body.pagingInfo
			});
		}

		if (data.header.code === 1) {
		}
		if (data.header.code === 2) {
		}
		if (data.header.code === 3) {
		}
		if (data.header.code === 4) {
		}
		if (data.header.code === 5) {
		}

		if (data.header.code === 500) {
			// somethinig todo
		} else {
			// somethinig todo
		}

		return data.header;
	},
	setConfirm_({ commit, dispatch }, { plantCd, payload }) {
		return api
			.setConfirm({ plantCd, payload })
			.then(header => {
				//dispatch('getProcesses');
				return header;
			})
			.catch(error => {
				throw error;
			});
	}
};
